import { Badge, Dropdown, Flex, Space, Tag, Tooltip, Typography } from "antd"
import dayjs from "dayjs"
// import AlertTransactionStatusAction from '../AlertTransactionStatusAction'
import utc from "dayjs/plugin/utc"

import ButtonComponent from "../../../../Components/Button"
import Button from "../../../../Components/Button"
import InfoTooltip from "../../../../Components/InfoTooltip/InfoTooltip"
import Private, { INCOGNITO_MASK } from "../../../../Components/Private"
import { titleSortFilters } from "../../../../Components/titleSortFilters"
import { useIncognito } from "../../../../hooks/useIncognito"
import Icon from "../../../../Icon"
import Images from "../../../../Images"
import { maskLogPII } from "../../../../Utils/incognito"
import {
  alertsColumnIconMap,
  alertsTooltipStatusText,
  dateFormat,
  paymentProcessorMap,
  pinIconColor,
  remainingTime,
  serviceImg,
  serviceMap,
  statusTextMap,
  tagColorMap,
  tagMap
} from "../../../../Utils/utils"

// import AlertTransactionStatusAction from '../AlertTransactionStatusAction'

dayjs.extend(utc)

const { Text, Link } = Typography

export const getColumns = ({
  t,
  options,
  handleChangeStatus,
  theme,
  isAdmin,
  onSelectRow,
  disabledStatus = false,
  strong = false,
  isDemo,
  withoutStatusTooltip = false,
  onOpenTransactionModal
}) => ({
  icon: {
    key: "pinned",
    title: "",
    dataIndex: "pinned",
    width: 64,
    fixed: "left",
    render: (_, record) => {
      if (record?.["alert_status"]?.toLowerCase() === "attention") {
        return <Icon type={"clock"} style={{ fontSize: "20px", margin: "0 6px" }} />
      } else {
        return (
          <Tooltip title={t(_ ? "Unpin" : "Pin")}>
            <ButtonComponent
              type="text"
              shape="circle"
              icon={<Icon color={pinIconColor[theme]} type={_ ? "pin_active" : "pin"} />}
              onClick={(e) => {
                e.stopPropagation()
                onSelectRow(record, "pin")
              }}
              className="flex center"
              style={{ padding: 0 }}
            />
          </Tooltip>
        )
      }
    }
  },
  id: {
    key: "id",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: null,
        sorter: true,
        icon: alertsColumnIconMap["id"],
        stateData: state,
        key: "id"
      }),
    dataIndex: "id",
    fixed: "left",
    width: 100
  },
  alert_status: {
    key: "alert_status",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Status"),
        sorter: true,
        icon: alertsColumnIconMap["alert_status"],
        stateData: state,
        key: "alert_status"
      }),
    dataIndex: "alert_status",
    fixed: "left",
    width: 180,
    render: (_, record) => {
      const isAttentionStatus = _?.toLowerCase() === "attention"
      const isTooltipHidden = disabledStatus || (!isAttentionStatus && !isAdmin)
      const tooltip =
        (record?.["user_error_message"] || record?.["error_message"]) && !isTooltipHidden ? (
          <Tooltip
            title={
              <Flex vertical={true} gap={8}>
                <span>{record?.["user_error_message"]}</span>
                {record?.["error_message"] ? <span>{record?.["error_message"]}</span> : null}
              </Flex>
            }
            destroyTooltipOnHide={true}
          >
            <div>
              <Icon type={"circle_info_simple"} style={{ color: "#D71313" }} />
            </div>
          </Tooltip>
        ) : (
          0
        )

      if (isAttentionStatus && !disabledStatus) {
        let time = remainingTime(
          record?.["alert_timestamp"],
          record?.["alert_service"],
          null,
          record?.["user_error_message"]
        )
        if (isDemo) time = null

        return (
          <Badge count={tooltip}>
            <Dropdown
              disabled={disabledStatus}
              menu={{
                items: options
                  ?.filter((status) =>
                    [
                      "manually refunded",
                      "declined",
                      "not found",
                      "not_found",
                      "failed transaction",
                      "previously refunded",
                      "already a chargeback"
                    ].includes(status?.toLowerCase())
                  )
                  ?.map((el) => {
                    let statusLowerCase = el?.toLowerCase()
                    let tooltipStatus = alertsTooltipStatusText[statusLowerCase]
                      ? t(alertsTooltipStatusText[statusLowerCase])
                      : null
                    return {
                      key: el,
                      label: (
                        <Tooltip
                          title={withoutStatusTooltip ? null : tooltipStatus}
                          placement={"right"}
                          destroyTooltipOnHide={true}
                        >
                          <Flex gap={8} align="center">
                            <Badge
                              status={tagMap[statusLowerCase] || "default"}
                              color={tagColorMap[el]}
                            />
                            <Text strong={strong}>{statusTextMap[el] || el}</Text>
                          </Flex>
                        </Tooltip>
                      )
                    }
                  }),
                onClick: ({ key, domEvent }) => {
                  domEvent.stopPropagation()
                  if (key !== _)
                    handleChangeStatus({
                      alert_id: record.alert_id,
                      newStatus: key,
                      record
                    })
                }
              }}
            >
              <Tag
                color={tagMap[_?.toLowerCase()] || "default"}
                key={_}
                className={"simple large"}
                style={{ margin: 0 }}
              >
                <Flex gap={8} align="center">
                  <Badge status={tagMap[_?.toLowerCase()] || "default"} color={tagColorMap[_]} />
                  <Text strong={strong}>{statusTextMap[_] || _}</Text>
                  {time ? (
                    <>
                      <Text
                        type="secondary"
                        strong={strong}
                        style={{
                          height: "4px",
                          lineHeight: "4px",
                          margin: "0 -4px"
                        }}
                      >
                        •
                      </Text>
                      <Text strong={strong}>{time}</Text>
                    </>
                  ) : null}
                  <Icon type="chevron_down_small" style={{ marginLeft: -4 }} />
                </Flex>
              </Tag>
            </Dropdown>
          </Badge>
        )
      } else {
        return (
          <Badge count={tooltip}>
            <Flex gap={8} align="center">
              <Tag
                color={tagMap[_?.toLowerCase()] || "default"}
                key={_}
                className={"simple large"}
                style={{ margin: 0 }}
              >
                <Flex gap={8} align="center">
                  <Badge status={tagMap[_?.toLowerCase()] || "default"} color={tagColorMap[_]} />
                  <Text strong={strong}>{statusTextMap[_] || _}</Text>
                </Flex>
              </Tag>
              {/* //TODO: CHA-6795
              {!disabledStatus && (
                <AlertTransactionStatusAction
                  alert={record}
                  status={_}
                  onOpen={onOpenTransactionModal}
                />
              )}
              */}
            </Flex>
          </Badge>
        )
      }
    }
  },
  alert_type: {
    key: "alert_type",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Type"),
        icon: alertsColumnIconMap["alert_type"],
        stateData: state,
        sorter: true,
        key: "alert_type"
      }),
    dataIndex: "alert_type",
    width: 110
  },
  alert_reason: {
    key: "alert_reason",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Alert reason"),
        icon: alertsColumnIconMap["alert_reason"],
        stateData: state,
        sorter: true,
        key: "alert_reason"
      }),
    dataIndex: "alert_reason",
    ellipsis: true
    //render: (_, record) => _ ? <a href={record?.['alert_reason_link']} target='_blank'>{_}</a> : '—'
  },
  user_full_name: {
    key: "user_full_name",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("User full name"),
        sorter: true,
        icon: alertsColumnIconMap["user_full_name"],
        stateData: state,
        key: "user_full_name"
      }),
    dataIndex: "user_full_name",
    width: 185,
    render: (value) => (value ? <Private>{value}</Private> : "—")
  },
  user_email: {
    key: "user_email",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("User email"),
        sorter: true,
        icon: alertsColumnIconMap["user_email"],
        stateData: state,
        key: "user_email"
      }),
    dataIndex: "user_email",
    width: 185,
    render: (value) => (value ? <Private>{value}</Private> : "—")
  },
  customer_email: {
    key: "customer_email",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        sorter: true,
        title: "Customer email",
        icon: alertsColumnIconMap["user_email"],
        stateData: state,
        key: "customer_email"
      }),
    dataIndex: "customer_email",
    width: 185,
    render: (value) =>
      value ? (
        <Text copyable={{ tooltips: false }} strong={strong}>
          <Private>{value}</Private>
        </Text>
      ) : (
        "—"
      )
  },
  customer_full_name: {
    key: "customer_full_name",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        sorter: true,
        title: "Customer full name",
        icon: alertsColumnIconMap["user_full_name"],
        stateData: state,
        key: "customer_full_name"
      }),
    dataIndex: "customer_full_name",
    width: 200,
    render: (value) => {
      return typeof value === "string" && value.trim() ? ( //after removing spaces from both ends, the string is not empty
        <Text copyable={{ tooltips: false }} strong={strong}>
          <Private>{value}</Private>
        </Text>
      ) : (
        "—"
      )
    }
  },
  transaction_timestamp: {
    key: "transaction_timestamp",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Transaction date"),
        sorter: true,
        icon: alertsColumnIconMap["transaction_timestamp"],
        stateData: state,
        key: "transaction_timestamp"
      }),
    dataIndex: "transaction_timestamp",
    width: 185,
    render: (_) => dayjs(_).format(dateFormat)
  },
  transaction_id: {
    key: "transaction_id",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Transaction ID"),
        icon: alertsColumnIconMap["transaction_id"],
        stateData: state,
        sorter: true,
        key: "transaction_id",
        dataTour: "transaction-id-column"
      }),
    dataIndex: "transaction_id",
    width: 185,
    //ellipsis: true,
    render: (_, record) => {
      if (!_?.length) return "—"
      const visibleIds = _?.slice(0, 2)
      const hasMore = _?.length > 2

      return (
        <Flex gap={4} wrap={true}>
          {visibleIds.map((id, idx) => (
            <a
              key={`${record.alert_id}_${idx}`}
              href={record?.["transaction_link"]?.[idx] || record?.["transaction_url"]?.[idx]}
              target="_blank"
              onClick={(e) => e.stopPropagation()}
              rel="noreferrer"
            >
              <Private>{`${id}${idx < visibleIds.length - 1 ? "," : ""}`}</Private>
            </a>
          ))}
          {hasMore && (
            <Tooltip title={t("View all mapped Transaction IDs in the View Details modal window")}>
              <Flex align="center">
                {t("See more")}
                <Tag bordered={false} color="processing" style={{ marginLeft: 8 }}>
                  {_?.length}
                </Tag>
              </Flex>
            </Tooltip>
          )}
        </Flex>
      )
    }
  },
  auth_code: {
    key: "auth_code",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Auth.Code"),
        icon: alertsColumnIconMap["transaction_id"],
        stateData: state,
        sorter: true,
        key: "auth_code"
      }),
    dataIndex: "auth_code",
    width: 185,
    render: (value) =>
      value ? (
        <Text copyable={{ tooltips: false }}>
          <Private>{value}</Private>
        </Text>
      ) : (
        "—"
      )
  },
  arn: {
    key: "arn",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("ARN"),
        icon: alertsColumnIconMap["transaction_id"],
        stateData: state,
        sorter: true,
        key: "arn"
      }),
    dataIndex: "arn",
    width: 185,
    render: (value) =>
      value ? (
        <Text copyable={{ tooltips: false }}>
          <Private>{value}</Private>
        </Text>
      ) : (
        "—"
      )
  },
  bin: {
    key: "bin",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("BIN"),
        icon: alertsColumnIconMap["transaction_id"],
        stateData: state,
        sorter: true,
        key: "bin"
      }),
    dataIndex: "bin",
    width: 185,
    render: (value) =>
      value ? (
        <Text copyable={{ tooltips: false }}>
          <Private>{value}</Private>
        </Text>
      ) : (
        "—"
      )
  },
  caid: {
    key: "caid",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("CAID"),
        icon: alertsColumnIconMap["transaction_id"],
        stateData: state,
        sorter: true,
        key: "caid"
      }),
    dataIndex: "caid",
    width: 185,
    render: (value) =>
      value ? (
        <Text copyable={{ tooltips: false }}>
          <Private>{value}</Private>
        </Text>
      ) : (
        "—"
      )
  },
  alert_timestamp: {
    key: "alert_timestamp",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Alert date"),
        sorter: true,
        icon: alertsColumnIconMap["alert_timestamp"],
        stateData: state,
        key: "alert_timestamp"
      }),
    dataIndex: "alert_timestamp",
    width: 140,
    render: (_) => (
      <Space direction="vertical" size={4}>
        <Text strong={strong}>{dayjs(_).format(dateFormat)}</Text>
        <Text type="secondary" strong={strong}>
          {dayjs(_).format("h:mm A [(UTC)]")}
        </Text>
      </Space>
    )
  },
  alert_service: {
    key: "alert_service",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Alert source"),
        sorter: true,
        icon: alertsColumnIconMap["alert_service"],
        stateData: state,
        key: "alert_service"
      }),
    dataIndex: "alert_service",
    width: 160,
    render: (_) => (
      <Space>
        <img src={Images[serviceImg?.[theme]?.[_]]} alt={_} />
        <Text strong={strong}>{serviceMap[_]}</Text>
        {!isAdmin && _ === "rdr" && (
          <InfoTooltip title="Refunds triggered by RDR may take some time to appear in your payment processor. This delay is expected." />
        )}
      </Space>
    )
  },
  amount: {
    key: "amount",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Order value"),
        sorter: true,
        icon: alertsColumnIconMap["amount"],
        stateData: state,
        key: "converted_amount"
      }),
    dataIndex: "converted_amount",
    width: 150,
    render: (_, record) => (
      <Space direction="vertical" size={4}>
        {record?.["converted_currency"] ? (
          <>
            <Text strong={strong}>
              <Private>{`${record?.["converted_currency"]} ${record?.["converted_amount"]}`}</Private>
            </Text>
            <Text type="secondary" strong={strong}>
              <Private>{`${record?.currency || ""} ${record?.amount}`}</Private>
            </Text>
          </>
        ) : (
          <Text strong={strong}>
            <Private>{`${record?.currency || ""} ${record?.amount}`}</Private>
          </Text>
        )}
      </Space>
    )
  },
  merchant_descriptor: {
    key: "merchant_descriptor",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Billing descriptor"),
        sorter: true,
        icon: alertsColumnIconMap["merchant_descriptor"],
        stateData: state,
        key: "merchant_descriptor"
      }),
    dataIndex: "merchant_descriptor",
    width: 185,
    render: (value) => (value ? <Private>{value}</Private> : "—")
  },
  country: {
    key: "country",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Country"),
        sorter: true,
        icon: alertsColumnIconMap["country"],
        stateData: state,
        key: "country"
      }),
    dataIndex: "country",
    width: 185
  },
  bank_name: {
    key: "bank_name",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Bank"),
        sorter: true,
        icon: alertsColumnIconMap["bank_name"],
        stateData: state,
        key: "bank_name"
      }),
    dataIndex: "bank_name",
    width: 140,
    render: (value) => (value ? <Private>{value}</Private> : "—")
  },
  card_last4: {
    key: "card_last4",
    title: (state) =>
      titleSortFilters({
        title: t("Card"),
        icon: alertsColumnIconMap["card_last4"],
        stateData: state,
        key: "card_last4"
      }),
    dataIndex: "card_last4",
    render: (_, record) => {
      return (
        <Space>
          {record?.brand && (
            <img
              src={Images[`${record?.brand?.toLowerCase()}${theme === "dark" ? "_dark" : ""}`]}
              width={20}
              height={20}
              alt={record?.brand}
            />
          )}
          {_ && record?.card_bin ? (
            <Text strong={strong}>
              <Private mask="••••">{`${record?.card_bin} ••• ${_}`}</Private>
            </Text>
          ) : (
            _ && (
              <Text strong={strong}>
                <Private mask="••••">{`•••• ${_}`}</Private>
              </Text>
            )
          )}
          {record?.is_card_potentially_tokenized && (
            <Tooltip
              title={
                <Flex vertical={true} gap={8}>
                  <span>
                    This card number is likely tokenized. As a result, the last four digits may be
                    incorrect. Matching based on them can be unreliable.
                  </span>
                </Flex>
              }
              destroyTooltipOnHide={true}
            >
              <div>
                <Icon type={"circle_info_simple"} style={{ color: "#D71313" }} />
              </div>
            </Tooltip>
          )}
        </Space>
      )
    },
    width: 210
  },
  payment_processor: {
    key: "payment_processor",
    title: (state) =>
      titleSortFilters({
        title: t("Payment processor"),
        icon: alertsColumnIconMap["payment_processor"],
        stateData: state,
        key: "payment_processor"
      }),
    dataIndex: "payment_processor",
    width: 185,
    render: (_) => (
      <Space>
        {_ !== "other" && _ !== "-" && Images[`integration_${_}`] && (
          <img src={Images[`integration_${_}`]} width={20} height={20} alt={_} />
        )}
        <Text strong={strong}>{paymentProcessorMap[_] || "—"}</Text>
      </Space>
    )
  },
  alert_id: {
    key: "alert_id",
    title: (state) =>
      titleSortFilters({
        title: t("Alert ID"),
        icon: alertsColumnIconMap["alert_id"],
        stateData: state,
        key: "alert_id"
      }),
    dataIndex: "alert_id",
    render: (value) => (
      <Text copyable={{ tooltips: false, text: value }} strong={strong}>
        <Private>{value}</Private>
      </Text>
    )
    //fixed: 'right',
  },
  customer_unsubscribed: {
    key: "customer_unsubscribed",
    title: (state) =>
      titleSortFilters({
        title: "Subscription canceled",
        icon: alertsColumnIconMap["customer_unsubscribed"],
        stateData: state,
        key: "customer_unsubscribed"
      }),
    dataIndex: "customer_unsubscribed",
    width: 230,
    render: (_) => (_ ? "Yes" : "No")
  },
  user_visibility: {
    key: "user_visibility",
    title: (state) =>
      titleSortFilters({
        title: "User visibility",
        icon: alertsColumnIconMap["user_visibility"],
        stateData: state,
        key: "user_visibility"
      }),
    dataIndex: "user_visibility",
    width: 140,
    render: (_) => (_ ? "Yes" : "No")
  },
  paid_status: {
    key: "paid_status",
    title: (state) =>
      titleSortFilters({
        title: "Paid status",
        icon: alertsColumnIconMap["paid_status"],
        stateData: state,
        key: "paid_status"
      }),
    dataIndex: "paid_status",
    width: 140
  },
  status_set: {
    key: "status_set",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: t("Status set"),
        sorter: true,
        icon: alertsColumnIconMap["status_set"],
        stateData: state,
        key: "status_set"
      }),
    dataIndex: "status_set",
    width: 140,
    render: (value) => value || "—"
  },
  credit_request_type: {
    key: "credit_request_type",
    title: (state) =>
      titleSortFilters({
        title: t("Credit request"),
        icon: alertsColumnIconMap["credit_request_type"],
        stateData: state,
        key: "credit_request_type"
      }),
    dataIndex: "credit_request_type",
    width: 170,
    render: (value) => value || "—"
  },
  original_alert_id: {
    key: "original_alert_id",
    title: (state) =>
      titleSortFilters({
        title: t("Original alert"),
        icon: alertsColumnIconMap["alert_id"],
        stateData: state,
        key: "original_alert_id"
      }),
    dataIndex: "original_alert_id",
    minWidth: 150,
    render: (value) => {
      if (!value) return "—"
      return (
        <Text copyable={{ tooltips: false }} strong={strong}>
          {value}
        </Text>
      )
    }
  },
  billing_descriptor_status: {
    key: "billing_descriptor_status",
    title: (state) =>
      titleSortFilters({
        title: t("Descriptor status"),
        icon: alertsColumnIconMap["billing_descriptor_status"],
        stateData: state,
        key: "billing_descriptor_status"
      }),
    dataIndex: "billing_descriptor_status",
    width: 180,
    render: (_) => {
      if (!_) return "—"
      return (
        <Tag
          color={tagMap[_?.toLowerCase()] || "default"}
          key={_}
          className={"simple large"}
          style={{ margin: 0 }}
        >
          <Flex gap={8} align="center">
            <Badge status={tagMap[_?.toLowerCase()] || "default"} color={tagColorMap[_]} />
            <Text strong={strong}>{statusTextMap[_]}</Text>
          </Flex>
        </Tag>
      )
    }
  }
})

export const getDefaultColumn = ({ field_id, label, t, icon }) => ({
  key: field_id,
  sorter: true,
  title: (state) =>
    titleSortFilters({
      title: t(label),
      sorter: true,
      icon,
      stateData: state,
      key: field_id
    }),
  dataIndex: field_id,
  ellipsis: true,
  width: 185,
  render: (_) => _ || "—"
})

export const getActionColumn = ({ onSelectRow }) => {
  const handleAction = (e, data, type) => {
    e.preventDefault()
    e.stopPropagation()
    onSelectRow(data, type)
  }
  return {
    key: "action",
    title: "",
    width: 64,
    fixed: "right",
    render: (_, record, index) => (
      <Flex gap={4} data-tour={index === 0 ? "alert-details" : null}>
        <Tooltip title="View Details">
          <ButtonComponent
            type="link"
            shape="circle"
            icon={<Icon type={"layout_align_right"} />}
            onClick={(e) => handleAction(e, record, "view_details")}
            className="flex center"
          />
        </Tooltip>
      </Flex>
    )
  }
}

export const HighlightStatusText = ({ text: rawText }) => {
  const incognito = useIncognito()
  const text = incognito ? maskLogPII(rawText, INCOGNITO_MASK) : rawText

  const STATUS_COLORS = {
    Lost: "danger",
    Attention: "warning",
    Warning: "warning",
    "Manually refunded": "success"
  }

  const statusKeys = Object.keys(STATUS_COLORS)
  const statusRegex = new RegExp(`\\b(${statusKeys.join("|")})\\b`, "g")
  const ticketRegex = /Ticket #(\d+)/g

  const renderHighlightedText = (text) => {
    const parts = []
    let lastIndex = 0

    text.replace(ticketRegex, (match, ticketId, index) => {
      if (index > lastIndex) {
        parts.push(text.slice(lastIndex, index))
      }
      parts.push(
        <Button
          size="small"
          type="link"
          key={`ticket-${ticketId}`}
          onClick={() => window?.Intercom?.("showTicket", Number(ticketId))}
          style={{ padding: "0", lineHeight: "17px" }}
        >
          {match}
        </Button>
      )
      lastIndex = index + match.length
    })

    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex))
    }

    return parts.map((part, index) => {
      if (typeof part === "string") {
        return part.split(statusRegex).map((subPart, subIndex) =>
          STATUS_COLORS[subPart] ? (
            <Text key={`${index}-${subIndex}`} type={STATUS_COLORS[subPart]}>
              {subPart}
            </Text>
          ) : (
            subPart
          )
        )
      }
      return part
    })
  }

  return <Text>{renderHighlightedText(text)}</Text>
}

export const getLogsColumns = ({ t }) => [
  {
    key: "log_message",
    title: t("Status"),
    dataIndex: "log_message",
    width: "50%",
    render: (_) => <HighlightStatusText text={_} />
  },
  {
    key: "created",
    title: t("Date"),
    dataIndex: "created",
    width: "50%",
    render: (_) => <Text>{dayjs(_).format("DD MMM YYYY h:mm A [(UTC)]")}</Text>
  }
]
